import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../../models/book-widget-fields-master-config.interfaces';

export const flexDatesRulesOnChangeEval = (
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig
): BookWidgetFields => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (updatedBookWidgetFields.flexDatesField.checked) {
    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      flexAirportsField: {
        ...updatedBookWidgetFields.flexAirportsField,
        hide:
          bookWidgetFieldsMasterConfig.flexAirportsField?.hide ||
          !updatedBookWidgetFields.shopMilesField.checked,
        checked: false
      }
    };
  } else {
    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      flexAirportsField: {
        ...updatedBookWidgetFields.flexAirportsField,
        hide: bookWidgetFieldsMasterConfig.flexAirportsField?.hide || false
      }
    };
  }

  return updatedBookWidgetFields;
};
